<template>
  <section class="page-section" v-loading="pageLoading">
    <el-form size="small" label-width="0px" class="content-form">
      <!-- 账户信息 -->
      <div class="form-module no-margin-top">
        <div class="module-header">基本信息</div>
        <div class="module-body clearfix">
          <div class="avatar">
            <img :src="detail.avatarUrl" />
          </div>
          <div class="info">
            <div class="flex-h">
              <div>
                <span class="text">ID：{{ detail.userId }}</span>
              </div>
            </div>
            <div class="flex-h">
              <div>
                <span class="text">呢称：</span>
              </div>
              <div>
                <span class="text">{{ detail.wechatNickName }}</span>
              </div>
              <div style="margin-left: 2em">
                <span class="text">会员等级：</span>
              </div>
              <div>
                <span class="text">{{ detail.userLevelName }}</span>
              </div>
              <template v-if="!detail.company">
                <div style="margin-left: 2em">
                  <span class="text">服务代理等级：</span>
                </div>
                <div>
                  <span class="text">{{
                    detail.myServiceAccountVo &&
                    detail.myServiceAccountVo.levelName
                  }}</span>
                </div>
                <div style="margin-left: 2em">
                  <span class="text">商品代理等级：</span>
                </div>
                <div>
                  <span class="text">{{
                    detail.myProductAccountVo &&
                    detail.myProductAccountVo.levelName
                  }}</span>
                </div>
                <div style="margin-left: 2em">
                  <span class="text">来源：</span>
                </div>
                <div>
                  <span class="text">{{ detail.source }}</span>
                </div>
              </template>
              <template v-if="detail.company">
                <div style="margin-left: 2em">
                  <span class="text">所属公司：</span>
                </div>
                <div>
                  <span class="text">{{ detail.company }}</span>
                </div>
              </template>
            </div>
            <div class="flex-h">
              <div>
                <span class="text">姓名：</span>
              </div>
              <div>
                <span class="text">{{ detail.userName }}</span>
              </div>
              <div style="margin-left: 2em">
                <span class="text">性别：</span>
              </div>
              <div>
                <span class="text" v-if="detail.sex == 0">男</span>
                <span class="text" v-if="detail.sex == 1">女</span>
              </div>
              <div style="margin-left: 2em">
                <span class="text">年龄：</span>
              </div>
              <div>
                <span class="text">{{ detail.age }}</span>
              </div>
            </div>
            <div class="flex-h">
              <div>
                <span class="text">手机号：</span>
              </div>
              <div class="flex-a-i">
                <span class="text mr-10">{{ detail.mobile }}</span>
              </div>
            </div>
            <div class="flex-h">
              <div>
                <span class="text">收货地址：</span>
              </div>
              <div class="flex-a-i">
                <p
                  class="text"
                  v-for="(addrItem, addrIndex) in detail.addressList"
                  :key="addrIndex"
                >
                  {{
                    addrItem.addressDetail +
                    "," +
                    addrItem.name +
                    ", " +
                    addrItem.mobile
                  }}
                </p>
              </div>
            </div>
            <div class="flex-h">
              <div>
                <span class="text">首次登录时间：</span>
              </div>
              <div class="flex-a-i">
                <span class="text">{{ detail.firstLoginTime }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 交易数据 -->
      <div class="form-module">
        <div class="module-header">交易数据</div>
        <div class="module-body">
          <div class="info flex-h" style="float: inherit">
            <div class="flex-a-i">
              <div>
                <span class="text">上次交易时间：</span>
                <span class="text">{{ detail.lastBuyTime }}</span>
              </div>
              <div>
                <span class="text">累计服务订单：</span>
                <span class="text">{{ detail.totalServiceOrderNum || 0 }}</span>
              </div>
              <div>
                <span class="text">累计服务订单金额：</span>
                <span class="text"
                  >￥{{ detail.totalServiceConsumePrice || 0 }}</span
                >
              </div>
            </div>
            <div class="flex-a-i">
              <div>
                <span class="text">&nbsp;</span>
                <span class="text"></span>
              </div>
              <div>
                <span class="text">累计商品订单：</span>
                <span class="text">{{ detail.totalProductOrderNum || 0 }}</span>
              </div>
              <div>
                <span class="text">累计商品订单金额：</span>
                <span class="text"
                  >￥{{ detail.totalProductConsumePrice || 0 }}</span
                >
              </div>
            </div>
            <div class="flex-a-i">
              <div>
                <span class="text">&nbsp;</span>
                <span class="text"></span>
              </div>
              <div>
                <span class="text">累计商品退款订单：</span>
                <span class="text">{{ detail.refundNum || 0 }}</span>
              </div>
              <div>
                <span class="text">累计商品退款订单金额：</span>
                <span class="text">￥{{ detail.refundPrice || 0 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 积分明细 -->
      <div class="form-module">
        <div class="module-header">积分明细</div>
        <div class="module-body">
          <!-- 增加积分 -->
          <el-button
            type="primary"
            size="small"
            @click="handleAddPointDialogShow"
            >录入订单积分</el-button
          >
          <el-button type="primary" size="small" @click="enterPointsDialogShow"
            >手动录入积分</el-button
          >
          <el-button type="primary" size="small" @click="refreshPoints"
            >刷新积分</el-button
          >
          <!-- 统计 -->
          <div class="statistics" style="margin-top: 10px">
            <span class="item"
              >可用积分：{{ statistics.availablePoint || 0 }}</span
            >
            <span class="item"
              >过期积分：{{ statistics.expirePoint || 0 }}</span
            >
            <span class="item"
              >已兑换积分：{{ statistics.exchangePoint || 0 }}</span
            >
            <span class="item"
              >冻结积分：{{ statistics.freezePoint || 0 }}</span
            >
          </div>
          <!-- 表格 -->
          <div
            class="table-region"
            style="margin-top: 0"
            v-loading="tableLoading"
          >
            <el-table size="small" :data="tableData">
              <el-table-column label=" ">
                <template slot-scope="scope">
                  <p>{{ getPointsStr(scope.row) }}</p>
                </template>
              </el-table-column>
              <el-table-column label=" ">
                <template slot-scope="scope">
                  <p>{{ scope.row.orderNo || "-" }}</p>
                </template>
              </el-table-column>
              <el-table-column label=" ">
                <template slot-scope="scope">
                  <p style="white-space: pre-line">
                    {{ scope.row.itemName || "-" }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column label=" ">
                <template slot-scope="scope">
                  <template
                    v-if="
                      scope.row.type == '0' ||
                      scope.row.type == '4' ||
                      scope.row.type == '7'
                    "
                  >
                    <p>订单金额：￥{{ scope.row.orderAmount }}</p>
                  </template>
                  <template
                    v-else-if="scope.row.type == '3' || scope.row.type == '5'"
                  >
                    <p>订单金额：{{ scope.row.point }}积分</p>
                  </template>
                  <template v-else>
                    <p>-</p>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label=" ">
                <template slot-scope="scope">
                  <p>
                    {{ getTimeStr(scope.row) }}:
                    {{ COMMON.formatDate("2", "-", scope.row.orderTime) }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column label=" ">
                <template slot-scope="scope">
                  <p>
                    {{
                      scope.row.userName && scope.row.userName != "-"
                        ? "用户: " + scope.row.userName
                        : "-"
                    }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="right">
                <template slot-scope="scope">
                  <el-popover
                    placement="left"
                    width="160"
                    v-model="scope.row.deleteVisible"
                    popper-class="confirm-popover"
                  >
                    <p>确定删除？</p>
                    <div>
                      <el-button
                        size="small"
                        type="default"
                        plain
                        @click="scope.row.deleteVisible = false"
                        >取消</el-button
                      >
                      <el-button
                        size="small"
                        type="primary"
                        @click="handleDelete(scope)"
                        >确定</el-button
                      >
                    </div>

                    <span class="text lh48 ml20" slot="reference"
                      ><el-button
                        size="small"
                        type="text"
                        :loading="deleteLoading"
                        >删除</el-button
                      ></span
                    >
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>

            <div class="table-footer" v-if="page.total > 0">
              <div class="selection-operate"></div>

              <div class="pagination-wrap">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[20, 50, 100]"
                  :current-page="page.current"
                  :page-size="page.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="page.total"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>

    <!-- 增加积分 -->
    <el-dialog title="增加积分" :visible.sync="dialogShow" width="400px">
      <el-form
        size="small"
        ref="formDialog"
        :model="formDialog"
        label-width="80px"
        class="dialog-form"
      >
        <el-form-item label="项目">
          <el-input
            v-model="formDialog.item"
            placeholder="项目名称,备注 (请用逗号分隔)"
          ></el-input>
        </el-form-item>
        <el-form-item label="实付金额">
          <el-input
            v-model="formDialog.actualAmount"
            type="number"
            :min="0"
            :max="9999999999"
            placeholder="请输入"
            @blur="handleAmountChange"
          ></el-input>
        </el-form-item>
        <el-form-item label="消费积分">
          <el-input
            v-model="formDialog.points"
            disabled
            placeholder="系统计算"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" plain @click="dialogShow = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="handleAddPointSave"
          :loading="dialogLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <EnterPoints
      :visible.sync="enterPointsDialog"
      @close="enterPointsDialog = false"
      @success="updatePageData"
    />
  </section>
</template>

<script>
import {
  COMMON,
  userUserDetail,
  getCurrentUserLevel,
  userDetailList,
  userPoints,
  agentSavePoints,
  agentDeletePoints,
  updatePsd,
  updatePoint,
} from "@/common/api";
import EnterPoints from "./components/enter-points.vue";
export default {
  components: {
    EnterPoints,
  },
  data() {
    return {
      COMMON,
      id: this.$route.query.id || "",
      pageLoading: true, // 页面loading
      detail: {}, // 详情
      tableData: [],
      tableLoading: false,
      page: {
        // 分页参数
        current: 1,
        size: 20,
        total: 0,
      },
      statistics: {
        availablePoint: 0,
        expirePoint: 0,
        exchangePoint: 0,
      },
      dialogShow: false,
      dialogLoading: false,
      formDialog: {
        item: "",
        actualAmount: "",
        points: "",
      },
      deleteLoading: false,
      operatePermission: COMMON.getPermissionStatus(10006), // 用户编辑权限
      enterPointsDialog: false,
    };
  },
  computed: {
    getPointsStr(row) {
      return function (row) {
        const { type, point } = row;
        if (type == "0") {
          return "消费积分 +" + point;
        } else if (type == "1") {
          return "分享积分 +" + point;
        } else if (type == "2") {
          return "积分过期 " + point;
        } else if (type == "3") {
          return "兑换商品 " + point;
        } else if (type == "4") {
          return "消费积分 +" + point;
        } else if (type == "5") {
          return "兑换项目 " + point;
        } else if (type == "6") {
          return "邀请用户注册 +" + point;
        } else if (type == "7") {
          return "分销首次奖励 +" + point;
        } else if (type == "8") {
          return "积分退回 +" + point;
        } else if (type == "9") {
          return "手动调整增加积分 +" + point;
        } else if (type == "10") {
          return "手动调整扣减积分 " + point;
        } else if (type == "11") {
          return "签到积分 +" + point;
        } else if (type == "12") {
          return "服务纪念日积分 +" + point;
        } else if (type == "13") {
          return "生日积分 +" + point;
        } else if (type == "14") {
          return "节日积分";
        } else if (type == "15") {
          return "商品/服务浏览";
        }
        return "-";
      };
    },
    getTimeStr(row) {
      return function (row) {
        const { type } = row;
        if (type == "0") {
          return "订单成交时间";
        } else if (type == "1") {
          return "下单时间";
        } else if (type == "2") {
          return "过期时间";
        } else if (type == "3") {
          return "兑换时间";
        } else if (type == "4") {
          return "订单成交时间";
        } else if (type == "5") {
          return "兑换时间";
        } else if (type == "6") {
          return "注册时间";
        } else if (type == "7") {
          return "首次分销时间";
        } else if (type == "9" || type == "10") {
          return "调整积分时间";
        } else if (type == "11") {
          return "签到积分";
        } else if (type == "12") {
          return "服务纪念日积分";
        } else if (type == "13") {
          return "生日积分";
        } else if (type == "14") {
          return "节日积分";
        } else if (type == "15") {
          return "商品/服务浏览";
        }
        return "-";
      };
    },
  },
  methods: {
    // 更新页面数据
    updatePageData() {
      this.getDetail();
      this.getStatics();
      this.getList();
    },
    /**
     * [getDetail description] 获取详情
     * @return {[type]} [description]
     */
    getDetail: function () {
      let params = {
        id: Number(this.id),
      };
      userUserDetail(params)
        .then((res) => {
          let { code, data, msg } = res;

          if (code == 0) {
            this.detail = data;
            this.pageLoading = false;
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },
    /**
     * [getStatics description] 统计
     * @return {[type]} [description]
     */
    getStatics: function () {
      let params = {
        userId: this.id,
      };

      userPoints(params)
        .then((res) => {
          let { code, data, msg } = res;

          if (code == 0) {
            const { availablePoint, expirePoint, exchangePoint, freezePoint } =
              data;
            Object.assign(this.statistics, {
              availablePoint,
              expirePoint,
              exchangePoint,
              freezePoint,
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },
    /**
     * [handleTabsChange description] 切换选项卡
     * @param  {[type]} tab   [description] 取name值用tab.name
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    handleTabsChange: function (tab, event) {
      this.page.current = 1;
      this.tableData = [];
      this.getList();
    },
    /**
     * [getList description] 获取 tab 列表数据
     * @return {[type]} [description]
     */
    getList: function () {
      this.tableLoading = true;

      let params = {
        userId: Number(this.id),
        current: this.page.current,
        size: this.page.size,
      };

      userDetailList(params)
        .then((res) => {
          let { code, data, msg } = res;

          if (code == 0) {
            this.tableData = data.records || [];
            this.tableLoading = false;
            this.page.total = data.total;
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.current = 1;
      this.page.size = val;

      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择分页第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;

      this.getList();
    },
    /**
     * [handleAddPointDialogShow description] 增加积分 - 弹窗 - 显示
     * @return {[type]}          [description]
     */
    handleAddPointDialogShow() {
      this.dialogLoading = false;
      Object.assign(this.formDialog, {
        item: "",
        actualAmount: "",
        points: "",
      });
      this.dialogShow = true;
    },
    enterPointsDialogShow() {
      this.enterPointsDialog = true;
    },
    // 刷新积分
    async refreshPoints() {
      let res = await updatePoint({ userId: this.id });
      if (res) {
        this.getDetail();
        this.getStatics();
        this.getList();
        this.$message.success("刷新完成");
      } else {
        this.$message.error("刷新失败");
      }
    },
    /**
     * [handleAddPointSave description] 增加积分 - 弹窗 - 保存
     * @return {[type]}          [description]
     */
    handleAddPointSave: function () {
      if (!this.formDialog.item) {
        this.$message.error("请输入项目名称,备注 (请用逗号分隔)");
        return false;
      }
      if (this.formDialog.actualAmount == "") {
        this.$message.error("请输入实付金额");
        return false;
      }

      this.dialogLoading = true;

      let param = {
        userId: this.id,
        item: this.formDialog.item,
        actualAmount: this.formDialog.actualAmount,
        points: this.formDialog.points,
      };

      agentSavePoints(param)
        .then((res) => {
          this.dialogLoading = false;
          this.dialogShow = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.$message.success("添加成功");
            this.updatePageData();
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
          this.dialogLoading = false;
        });
    },
    handleAmountChange() {
      this.dialogLoading = true;
      const { actualAmount } = this.formDialog;
      getCurrentUserLevel({
        actualAmount:
          Number(this.detail.totalServiceConsumePrice) + Number(actualAmount),
      }).then((res) => {
        const { shoppingPercent } = res.data;
        const num = Number(actualAmount);
        if (!isNaN(num) && num > 0) {
          Object.assign(this.formDialog, {
            points: (actualAmount * shoppingPercent) / 100,
          });
          this.dialogLoading = false;
        } else {
          this.$message.error("请输入大于0的数字");
          Object.assign(this.formDialog, {
            actualAmount: "",
          });
        }
      });
    },
    /**
     * [handleDelete description] 删除
     * @param  {[Object]} scope [description] 操作行的对象
     * @return {[type]}     [description]
     */
    handleDelete: function (scope) {
      this.deleteLoading = true;

      let params = {
        id: scope.row.id,
      };

      agentDeletePoints(params)
        .then((res) => {
          this.deleteLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.deleteLoading = false;
          this.$message.error("服务器异常");
        });
    },
  },
  mounted: function () {
    this.getDetail();
    this.getStatics();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/_mixin-font";
@import "../../../common/styles/base/mixin-common";

::v-deep .el-table__header-wrapper {
  height: 0;
  overflow: hidden;
}

.statistics {
  margin-top: -10px;
  padding: 10px;
  background: #effaff;
  border-radius: 4px;
  font-size: 0;

  &.default {
    border: 1px solid #d9d9d9;
    background: transparent;
  }

  .item {
    font-size: 12px;
    color: #222222;
    letter-spacing: 0;
    font-weight: 600;

    & + .item {
      margin-left: 80px;
    }
  }
}

.no-margin-top {
  margin-top: 0;
}

.mr-10 {
  margin-right: 10px;
}

.mr-20 {
  margin-right: 20px;
}

.pt-pb-10 {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.item-tab-body {
  margin: 10px 0;
  font-size: $smallFS;

  div {
    position: relative;
    display: inline-block;
    padding: 10px 30px;
    cursor: pointer;

    &.current {
      color: $themeColor;

      &:after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 3px;
        background: $themeColor;
        z-index: 1;
      }
    }
  }
}

.order-list-item {
  &.only-bottom-border {
    border: none;
    border-bottom: 1px solid $separateDefaultColor !important;
  }

  .customTableDropDownListBackgroundColor {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 10px 5px;
    background-color: $customTableDropDownListBackgroundColor;
  }

  .overdue {
    opacity: 0.5;
    filter: alpha(opacity=50);
  }

  .item-body-body {
    margin: 0 10px;

    &.no-margin {
      margin: 0;
    }

    .item-body-body-header {
      background-color: $colorTitleBg;
    }

    .item-body-body-body {
      padding: 10px 0;
    }
  }
}

.module-body {
  .text {
    font-size: $smallFS;
    color: $textColor;
    line-height: 28px;
  }

  .avatar {
    position: relative;
    float: left;
    width: 150px;
    height: 150px;
    margin-left: 10px;
    /*background: $colorImgBg;*/

    img {
      max-width: 100%;
      max-height: 100%;
      @include position(absolute, 1, 50%, none, none, 50%);
      @include translate(-50%, -50%, 0);
    }
  }

  .info {
    float: left;
    margin-left: 20px;
  }

  .personal-info-box {
    margin-bottom: 40px;

    .personal-info {
      float: left;
      margin-left: 10px;
    }

    .personal-avatar-info {
      float: left;
      margin-left: 40px;

      .personal-avatar {
        position: relative;
        margin-top: 5px;
        width: 200px;
        height: 130px;
        background: $colorImgBg;

        img {
          max-width: 100%;
          max-height: 100%;
          @include position(absolute, 1, 50%, none, none, 50%);
          @include translate(-50%, -50%, 0);
        }
      }
    }

    .personal-first-avatar-info {
      float: left;
      margin-left: 40px;

      .personal-first-avatar {
        position: relative;
        margin-top: 5px;
        width: 200px;
        height: 130px;
        background: $colorImgBg;

        img {
          max-width: 100%;
          max-height: 100%;
          @include position(absolute, 1, 50%, none, none, 50%);
          @include translate(-50%, -50%, 0);
        }
      }
    }
  }
}

.dialog-photo-past {
  position: relative;
  margin: 0 auto;
  padding: 10px 0;

  p {
    margin-bottom: 20px;
    text-align: center;
  }

  .pic-list {
    position: relative;
    margin: 0 auto;
    width: 420px;
    height: 130px;

    .pic-item {
      position: relative;
      width: 110px;
      height: 130px;
      margin: 0 15px;
      background: $colorImgBg;

      img {
        @include position(absolute, 3, 50%, none, none, 50%);
        max-width: 100%;
        max-height: 100%;
        @include translate(-50%, -50%, 0);
      }
    }
  }

  .left-icon,
  .right-icon {
    position: absolute;
    z-index: 5;
    top: 50%;
    margin-top: -20px;
    font-size: 34px;
    color: $swiperArrowColor;
    cursor: pointer;

    &:hover {
      color: $darkButtonBackgroundHoverColor;
    }

    &[disabled="disabled"] {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }

  .left-icon {
    left: 0;
  }

  .right-icon {
    right: 0;
  }
}

.goods-title {
  position: relative;
  padding-left: 58px;
  min-height: 48px;

  .thumb-wrap {
    @include position(absolute, 3, 50%, none, none, 0);
    width: 48px;
    height: 48px;
    margin-top: -24px;
    background-color: $colorPageBg;

    img {
      max-width: 100%;
      max-height: 100%;
      @include position(absolute, 1, 50%, none, none, 50%);
      @include translate(-50%, -50%, 0);
    }
  }

  p {
    line-height: 1.4;

    & + p {
      margin-top: 5px;
    }
  }
}

.statistics {
  margin-top: -10px;
  padding: 10px;
  background: #effaff;
  border-radius: 4px;
  font-size: 0;

  .item {
    font-size: 12px;
    color: #222222;
    letter-spacing: 0;
    font-weight: 600;

    & + .item {
      margin-left: 80px;
    }
  }
}
</style>
